/* eslint-disable no-underscore-dangle */
import { createAction } from '@reduxjs/toolkit';
import type { SoftwareReleaseState } from '../reducers/software-release';
import type { AppThunk } from '../store/configureStore';
import { showAPIError } from './api-error';

type SoftwareRelease = SoftwareReleaseState['softwareRelease'];
type SoftwareReleases = SoftwareReleaseState['softwareReleases'];

export const CLEAR_SOFTWARE_RELEASES = createAction<void>('CLEAR_SOFTWARE_RELEASES');
export const CLEAR_SOFTWARE_RELEASE = createAction<void>('CLEAR_SOFTWARE_RELEASE');
export const GET_SOFTWARE_RELEASES = createAction<SoftwareReleases>('GET_SOFTWARE_RELEASES');
export const CREATE_SOFTWARE_RELEASE = createAction<SoftwareRelease>('CREATE_SOFTWARE_RELEASE');
export const UPDATE_SOFTWARE_RELEASE = createAction<SoftwareRelease>('UPDATE_SOFTWARE_RELEASE');
export const GET_SOFTWARE_RELEASE = createAction<SoftwareRelease>('GET_SOFTWARE_RELEASE');
export const DELETE_SOFTWARE_RELEASE = createAction<void>('DELETE_SOFTWARE_RELEASE');

export const createSoftwareRelease =
  (postData: Record<string, unknown> = {}): AppThunk =>
  async (dispatch) => {
    const response = await fetch('/api/software-releases', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({ _csrf_token: (window as any)._csrf_token, ...postData }),
    });
    if (!response.ok) {
      dispatch(showAPIError(await response.json()));
      return;
    }
    dispatch(CREATE_SOFTWARE_RELEASE(await response.json()));
  };

export const updateSoftwareRelease =
  (id: string, patchData: Record<string, unknown> = {}): AppThunk =>
  async (dispatch) => {
    const response = await fetch(`/api/software-releases/${id}`, {
      method: 'PATCH',
      credentials: 'same-origin',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({ _csrf_token: (window as any)._csrf_token, ...patchData }),
    });
    if (!response.ok) {
      dispatch(showAPIError(await response.json()));
      return;
    }
    dispatch(UPDATE_SOFTWARE_RELEASE(await response.json()));
  };

export const getSoftwareReleases =
  (query = ''): AppThunk =>
  async (dispatch) => {
    const response = await fetch(`/api/software-releases?${query}`);
    if (!response.ok) {
      dispatch(showAPIError(await response.json()));
      return;
    }
    dispatch(GET_SOFTWARE_RELEASES(await response.json()));
  };

export const getSoftwareRelease =
  (id: string): AppThunk =>
  async (dispatch) => {
    const response = await fetch(`/api/software-releases/${id}`);
    if (!response.ok) {
      dispatch(showAPIError(await response.json()));
      return;
    }
    dispatch(GET_SOFTWARE_RELEASE(await response.json()));
  };

export const deleteSoftwareRelease =
  (id: string): AppThunk =>
  async (dispatch) => {
    const response = await fetch(`/api/software-releases/${id}`, {
      method: 'DELETE',
      credentials: 'same-origin',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({ _csrf_token: (window as any)._csrf_token }),
    });
    if (!response.ok) {
      dispatch(showAPIError(await response.json()));
      return;
    }
    dispatch(DELETE_SOFTWARE_RELEASE());
  };

export const clearSoftwareReleases = (): AppThunk => async (dispatch) =>
  dispatch(CLEAR_SOFTWARE_RELEASES());

export const clearSoftwareRelease = (): AppThunk => async (dispatch) =>
  dispatch(CLEAR_SOFTWARE_RELEASE);

export const testRunSoftwareRelease =
  (query = ''): AppThunk =>
  async (dispatch) => {
    const response = await fetch(`/api/software-releases/test?${query}`);
    if (!response.ok) {
      dispatch(showAPIError(await response.json()));
      return;
    }
    dispatch(GET_SOFTWARE_RELEASE(await response.json()));
  };
